export const SHIPPING_GROUP_ID = 12;

const excludedGroupIds = [SHIPPING_GROUP_ID];

export default excludedGroupIds;
